import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection, documentId } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
// Icons
import { MdOutlinePayments } from "react-icons/md";
import { VscSmiley } from "react-icons/vsc";
import { GetAgoTime } from '../components/getAgoTime';
import { CiBookmarkCheck, CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoBusinessOutline, IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { HiMiniBars3BottomRight } from "react-icons/hi2";
//page links       
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import './skillscategories.css';
import { IoIosArrowForward } from "react-icons/io";
export default function Skillscategories({ data = {} }) {
  const location = useLocation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
  const [loading, setLoading] = useState(true);
  const [CompanysUi, setCompanysUi] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [jobcategories, setJobcategories] = useState([]);
  const [Jobtasks, setJobtasks] = useState([]);
  const [Companytypes, setCompanytypes] = useState([]);
  const [selectcompanytypes, setSelectcompanytypes] = useState([]);
  const [appliedJobcategories, setAppliedJobcategories] = useState([]);
  const [companysindustry, setCompanysindustry] = useState([]);
  const [selectcompanysindustry, setSelectcompanysindustry] = useState([]);
  const [Pagetitle, setPagetitleData] = useState('Find the Right Job or Talent Faster');
  const [Pagedescription, setPagedescriptionData] = useState(
    'Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers.'
  );
  const handleCheckboxChange = (category) => (e) => {
    if (e.target.checked) {
      // Add to applied
      setAppliedJobcategories((prev) => [...prev, category]);
    } else {
      // Remove from applied
      setAppliedJobcategories((prev) =>
        prev.filter((item) => item !== category)
      );
    }
  };
  //Selectcompanysindustry  
  const handlecompanysindustryChange = (industry) => (e) => {
    if (e.target.checked) {
      // Add to applied
      setSelectcompanysindustry((prev) => [...prev, industry]);
    } else {
      // Remove from applied
      setSelectcompanysindustry((prev) =>
        prev.filter((item) => item !== industry)
      );
    }
  };
  //selectcompanytypes 
  const handleselectcompanytypesChange = (industry) => (e) => {
    if (e.target.checked) {
      // Add to applied
      setSelectcompanytypes((prev) => [...prev, industry]);
    } else {
      // Remove from applied
      setSelectcompanytypes((prev) =>
        prev.filter((item) => item !== industry)
      );
    }
  };

  const industry_ArrowUp = (e) => {
    const jobcategoriesgrid = document.querySelector('.industry-grid');
    if (jobcategoriesgrid) {
      const isHidden = jobcategoriesgrid.style.display === 'none';
      jobcategoriesgrid.style.display = isHidden ? 'block' : 'none';
      // Rotate the clicked arrow element
      e.currentTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
      //e.currentTarget.style.transition = 'transform 0.3s ease';
    }
  };
  const selectcompanytypes_ArrowUp = (e) => {
    const jobcategoriesgrid = document.querySelector('.companytypes-grid');

    if (jobcategoriesgrid) {
      const isHidden = jobcategoriesgrid.style.display === 'none';

      jobcategoriesgrid.style.display = isHidden ? 'block' : 'none';

      // Rotate the clicked arrow element
      e.currentTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
      //e.currentTarget.style.transition = 'transform 0.3s ease';
    }
  };
  //
  const Sector_ArrowUp = (e) => {
    const jobcategoriesgrid = document.querySelector('.jobcategories-grid');

    if (jobcategoriesgrid) {
      const isHidden = jobcategoriesgrid.style.display === 'none';
      jobcategoriesgrid.style.display = isHidden ? 'block' : 'none';
      // Rotate the clicked arrow element
      e.currentTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
      //e.currentTarget.style.transition = 'transform 0.3s ease';
    }
  };
  const companies_ArrowUp = (e) => {
    const jobcategoriesgrid = document.querySelector('.companies-grid');
    if (jobcategoriesgrid) {
      const isHidden = jobcategoriesgrid.style.display === 'none';
      jobcategoriesgrid.style.display = isHidden ? 'block' : 'none';
      // Rotate the clicked arrow element
      e.currentTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
      //e.currentTarget.style.transition = 'transform 0.3s ease';
    }
  };
  useEffect(() => {
    if (data?.title) {
      setPagetitleData(data.title);
    }
    if (data?.description) {
      setPagedescriptionData(data.description);
    }
  }, [data]);
  //jobcategories
  useEffect(() => {
    const fetchjobcategoriesData = async () => {
      try {
        const q = query(
          collection(db, "postdata")//,
          //  where("visibility", "==", true),
          // where("skillsId", "==",data.skillsId),
          // orderBy("title")
        );
        const querySnapshot = await getDocs(q);
        const seenJobcategoryIds = new Set();
        const uniqueJobcategories = [];
        const jobcategoryCounts = {}; // New: store counts
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (!seenJobcategoryIds.has(data.jobcategoryId)) {
            seenJobcategoryIds.add(data.jobcategoryId);
            uniqueJobcategories.push({ id: doc.id, ...data });
          }
          // Count posts per jobcategoryId
          if (data.jobcategoryId) {
            jobcategoryCounts[data.jobcategoryId] = (jobcategoryCounts[data.jobcategoryId] || 0) + 1;
          }
        });
        // Save both jobcategories and counts
        setJobcategories(uniqueJobcategories.map(job => ({
          ...job,
          count: jobcategoryCounts[job.jobcategoryId] || 0,
        })));
        setIsLoading(false);
      } catch (error) {
        console.error("Error job categories:", error);
        setIsLoading(false);
      }
    };
    fetchjobcategoriesData();
  }, []);
  //Hiring Jobtasks
  //Jobtasks
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        const q = query(
          collection(db, "postdata")//,
          // where("skillsId", "==", data.skillsId),
          //where("visibility", "==", true)
        );
        const querySnapshot = await getDocs(q);
        const JobtasksList = await Promise.all(
          querySnapshot.docs.map(async doc => {
            const jobData = { id: doc.id, ...doc.data() };

            // Fetch corresponding company data
            const cq = query(
              collection(db, "companys"),
              where("uid", "==", jobData.companysuid),
              where("status", "==", true)
            );
            const companysSnapshot = await getDocs(cq);
            const companyData = companysSnapshot.docs.map(cdoc => ({
              id: cdoc.id,
              ...cdoc.data()
            }))[0]; // Assuming only one company per job
            return {
              ...jobData,
              company: companyData || null
            };
          })
        );
        setJobtasks(JobtasksList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching Jobtasks:", error);
        setIsLoading(false);
      }
    };
    fetchJobtasks();
  }, []);

  //companys-ui-grid
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        const q = query(
          collection(db, "companys"),
          where("status", "==", true)
        );
        const companysSnapshot = await getDocs(q);
        const companysList = companysSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setCompanysUi(companysList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching companys:", error);
        setIsLoading(false);
      }
    };
    fetchJobtasks();
  }, []);

  //companys Industry  
  useEffect(() => {
    fetchCompanysIndustryData();
  }, [data.skillsId]);
  const fetchCompanysIndustryData = async () => {
    try {
      // 1. Get postdata with matching skillsId and status

      const postdataQuery = query(
        collection(db, "postdata"),
        where("skillsId", "==", data.skillsId),
        where("visibility", "==", true)
      );
      const postdataSnapshot = await getDocs(postdataQuery);

      // 2. Get unique companyuids from postdata
      const companyUids = [
        ...new Set(postdataSnapshot.docs.map(doc => doc.data().companysuid))
      ];

      if (companyUids.length === 0) {
        setCompanysindustry("");
        setCompanytypes(""); // Add this to reset companytypes if no companies
        setIsLoading(false);
        return;
      }

      const industriesSet = new Set();
      const companyTypesSet = new Set(); // Set to store unique company types

      // 3. Firestore allows max 10 items in "in" query
      const batchSize = 10;

      // Batch querying
      for (let i = 0; i < companyUids.length; i += batchSize) {
        const batch = companyUids.slice(i, i + batchSize); // Slice the companyUids into smaller chunks

        const companysQuery = query(
          collection(db, "companys"),
          where("companysuid", "in", batch), // Use the batch of companyUids here
          where("status", "==", true)
        );

        const companysSnapshot = await getDocs(companysQuery);

        companysSnapshot.forEach(doc => {
          const company = doc.data();

          if (company.industry) {
            industriesSet.add(company.industry.trim()); // Add unique industries to the Set
          }

          if (company.company_types) {
            companyTypesSet.add(company.company_types.trim()); // Add unique company types to the Set
          }
        });
      }

      // 4. Set final industries and company types without duplicates
      setCompanysindustry(Array.from(industriesSet).join(", "));
      setCompanytypes(Array.from(companyTypesSet).join(", ") || ""); // Ensure it's a string
      setIsLoading(false);

    } catch (error) {
      console.error("Error fetching company industry data:", error);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <div className="status-bar">
        <div className="container_size">
          <div className="status-bar_size">
            <div className='left_body'>
              <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
            </div>
            <div className='name-bar-body'>{data.title}</div>
            <div className='right_body'>
              <div

                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                title="Help Center"
              >
                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                <span className="button-text">Help</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='app_header_height'></div>
      <div className="container_roots">
        <Helmet>
          <title>{Pagetitle} | Featured Companies Actively Hiring</title>

          <meta name="description" content={Pagedescription} />
          <meta
            name="keywords"
            content={`${Pagedescription}, job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work`}
          />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta
            property="og:title"
            content={`${Pagetitle} | Featured Companies Actively Hiring`}
          />
          <meta property="og:description" content={Pagedescription} />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={typeof window !== 'undefined' ? window.location.href : 'https://www.editortask.com/'}
          />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
        </Helmet>

        <div className="container_size">

          <div className='post-container'>
            <div className='post_div'>
              <div className='contact-title'>{Pagetitle}: Featured Companies Actively Hiring</div>

            </div>

          </div>

          <div className='data-body'>
            <div className='post-container'>
              {/* filtesrs */}
              <div className='post_updates'>
                <div className='filtesrs-hd-div' >
                  <HiMiniBars3BottomRight
                    className='close-filters-img'
                    onClick={() => {
                      const element = document.querySelector('.filters-grid');
                      if (element) {
                        const currentDisplay = window.getComputedStyle(element).display;
                        if (currentDisplay === 'block') {
                          element.style.display = 'none';
                        } else {
                          element.style.display = 'block';
                        }
                      }
                    }}
                  />
                  <div className='filtesrs-applied'>
                    {appliedJobcategories.length > 0 && (
                      <div >Applied ({appliedJobcategories.length})</div>
                    )}
                  </div>
                </div>
                <div className='filters-grid'>
                  <div className='jobcategories-view'>

                    {/* jobcategories */}
                    <div className='filtesrs-div' >
                      <div className='filtesrs-title'>Sector</div>
                      <IoIosArrowUp onClick={Sector_ArrowUp} className='lable-arrow'></IoIosArrowUp>

                    </div>

                    <div className="jobcategories-grid">
                      {isLoading ? (
                        <Lodinging />
                      ) : (
                        jobcategories.map((jobcategorieslist, index) => (

                          <div
                            key={index}
                            className="jobcategories"
                            style={{ cursor: 'pointer' }}
                          >

                            <label
                              className="title-text"
                              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                              <input className='checkbox'
                                type="checkbox"
                                checked={appliedJobcategories.includes(jobcategorieslist.categoryId)}
                                onChange={handleCheckboxChange(jobcategorieslist.categoryId)}
                              />
                              {jobcategorieslist.title} ({jobcategorieslist.count})
                            </label>
                          </div>
                        ))
                      )}
                    </div>


                    {/* Industry */}

                    <div className='filtesrs-div'>
                      <div className='filtesrs-title'>Industry </div>
                      <IoIosArrowUp onClick={industry_ArrowUp} className='lable-arrow'></IoIosArrowUp>
                    </div>
                    {/* <input className='searchinput' placeholder='Industry ...' ></input>   */}
                    <div className="industry-grid" id="industry">
                      {isLoading ? (
                        <Lodinging />
                      ) : companysindustry.length > 0 ? (
                        companysindustry.split(',').map((industry, index) => {
                          const trimmedIndustry = industry.trim();
                          return (
                            <div
                              key={index}
                              className="jobcategories"
                              style={{ cursor: 'pointer' }}
                            >
                              <label
                                className="title-text"
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                              >
                                <input
                                  className="checkbox"
                                  type="checkbox"
                                  checked={selectcompanysindustry.includes(trimmedIndustry)}
                                  onChange={handlecompanysindustryChange(trimmedIndustry)}
                                />
                                {trimmedIndustry}
                              </label>
                            </div>
                          );
                        })
                      ) : (
                        <div>No industries found.</div>
                      )}
                    </div>

                  </div>

                  {/* Company type*/}
                  {/* <div className='jobcategories-view'>
                    <div className='filtesrs-div'>
                      <div className='filtesrs-title'>Company type</div>
                      <IoIosArrowUp onClick={selectcompanytypes_ArrowUp} className='lable-arrow'></IoIosArrowUp>
                    </div>
                    <div className="companytypes-grid">
                      {isLoading ? (
                        <Lodinging />
                      ) : (
                        // Ensure Companytypes is a string before calling .split
                        (Companytypes && Companytypes.length > 0 ? Companytypes : "").split(',').map((companytypeslist, index) => {
                          const trimmedcompanytypeslist = companytypeslist.trim();
                          return (
                            <div
                              key={index}
                              className="jobcategories"
                              style={{ cursor: 'pointer' }}
                            >
                              <label
                                className="title-text"
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                              >
                                <input
                                  className="checkbox"
                                  type="checkbox"
                                  checked={selectcompanytypes.includes(trimmedcompanytypeslist)}
                                  onChange={handleselectcompanytypesChange(trimmedcompanytypeslist)}
                                />
                                {trimmedcompanytypeslist}
                              </label>
                            </div>
                          );
                        })
                      )}
                    </div>

                  </div> */}


                </div>
              </div>
              {/* companys-ui-grid*/}
              <div className='post_div'>

                <div className="Tasks-grid">
                  {isLoading ? (
                    <Lodinging />
                  ) : (
                    Jobtasks.map((Jobtask, index) => (
                      <div
                        key={index}
                        className="Tasks-items"
                      >
                        {Jobtask.company && (
                          <div className="company-hiring" onClick={() => navigate(`/${Jobtask.slug}`)}>

                            <div className='hir-div'>
                              <div className="title-text">{Jobtask.jobcategories}</div>

                              <div className='hir-info-div'>
                                <b className='company'>{Jobtask.company.companyname}</b>
                                <div className='items-box'>
                                  <FaStar className='items-rating' />
                                  <a className='reviews'>
                                    {Jobtask.company.rating + " | " + Jobtask.company.reviws + " reviews"}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className='hir-logo-div'>
                              <img
                                className="hir-logo-img"
                                src={Jobtask.company.logo}
                                alt="Logo"
                                onLoad={() => setLoading(false)}
                                onError={() => setLoading(false)} // also hides loader if there's an error
                                style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                              />
                            </div>
                          </div>
                        )}
                        <div className='job-info-body' onClick={() => navigate(`/${Jobtask.slug}`)}>
                          <div className='job-info'>

                            <table className='experience-table'>
                              <tr><td>
                                <RiSlideshowLine className='job_biz_icon' />
                              </td>
                                <td>
                                    <a className='Jobtask-category-text'> {Jobtask.category.replace(/-/g, " ")}</a>
                                </td>
                              </tr>
                              <tr><td>
                                <LuBriefcaseBusiness className='job_biz_icon' />
                              </td>
                                <td>
                                  <a> {Jobtask.experience}</a>
                                </td>
                              </tr>

                              <tr><td>
                                <MdOutlinePayments className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'> {Jobtask.currency + " " + Jobtask.budget + "/- " + Jobtask.budgetpackage.replace(/-/g, " ")}</a>
                                </td>
                              </tr>
                              <tr><td>
                                <CiLocationOn className='job_biz_icon' />
                              </td>
                              <td>
<a className="job_biz_text">
  {Jobtask.currency} <b>{Jobtask.budget}/- </b>{Jobtask.budgetpackage.replace(/-/g, " ")}
</a>
                            </td>
                              </tr>
                            </table>
                          </div>
                          <div className='job-info'>
                            <table className='experience-table'>
                              <tr><td>
                                <IoDocumentTextOutline className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'> Greetings: {Jobtask.title}</a>
                                </td>
                              </tr>
                              <tr><td>
                                <BsPersonWorkspace className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'>{Jobtask.skills}</a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div className='job-save-div' title='Save'>
                          <div className='date-lable'>{GetAgoTime(Jobtask.date_time)}</div>
                          <div className='save_note'>
                            <CiBookmark className='save_icon' />

                            <div className='save_text'>Save</div>
                          </div>
                        </div>

                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='skills-title-div padding'>
            {/* <div className='header-text'>{Pagetitle}: Featured Companies Actively Hiring</div> */}
            <div className='skills-header-text'>{Pagedescription}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
